'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _arrify = require('arrify');

var _arrify2 = _interopRequireDefault(_arrify);

var _condenseKeys = require('condense-keys');

var _condenseKeys2 = _interopRequireDefault(_condenseKeys);

var _magicVirtualElement = require('magic-virtual-element');

var _magicVirtualElement2 = _interopRequireDefault(_magicVirtualElement);

var _nouislider = require('nouislider');

var _nouislider2 = _interopRequireDefault(_nouislider);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/** @jsx dom */
var propTypes = {
	class: {
		type: 'string'
	},
	connect: {
		type: 'string'
	},
	maxDistance: {
		type: 'number'
	},
	minDistance: {
		type: 'number'
	},
	onChange: {
		type: 'function'
	},
	onEnd: {
		type: 'function'
	},
	onSet: {
		type: 'function'
	},
	onSlide: {
		type: 'function'
	},
	onStart: {
		type: 'function'
	},
	onUpdate: {
		type: 'function'
	},
	range: {
		type: 'object'
	},
	rtl: {
		type: 'boolean'
	},
	start: {
		type: 'array'
	},
	step: {
		type: 'number'
	},
	tooltips: {
		type: 'function'
	},
	vertical: {
		type: 'boolean'
	}
};

var defaultProps = {
	connect: 'lower',
	maxDistance: null,
	minDistance: null,
	range: {
		max: 100,
		min: 0
	},
	rtl: false,
	start: [0],
	step: null,
	vertical: false
};

var parse = function parse(arr) {
	return arr.map(function (x) {
		return parseFloat(x);
	});
};

var afterMount = function afterMount(_ref, el) {
	var props = _ref.props;
	var connect = props.connect,
	    maxDistance = props.maxDistance,
	    minDistance = props.minDistance,
	    onChange = props.onChange,
	    onEnd = props.onEnd,
	    onSet = props.onSet,
	    onSlide = props.onSlide,
	    onStart = props.onStart,
	    onUpdate = props.onUpdate,
	    range = props.range,
	    rtl = props.rtl,
	    start = props.start,
	    step = props.step,
	    tooltips = props.tooltips,
	    vertical = props.vertical;

	var arr = (0, _arrify2.default)(start);

	if (!arr.length) {
		arr.push(range.min);
	}

	if (connect === true && arr.length !== 2) {
		arr.push(range.max);
	}

	_nouislider2.default.create(el, (0, _condenseKeys2.default)({
		connect: connect,
		direction: rtl ? 'rtl' : 'ltr',
		limit: maxDistance,
		margin: minDistance,
		orientation: vertical ? 'vertical' : 'horizontal',
		range: range,
		start: arr,
		step: step,
		tooltips: tooltips
	}));

	if (onChange) {
		el.noUiSlider.on('change', function (e) {
			return onChange(parse(e));
		});
	}

	if (onEnd) {
		el.noUiSlider.on('end', function (e) {
			return onEnd(parse(e));
		});
	}

	if (onSet) {
		el.noUiSlider.on('set', function (e) {
			return onSet(parse(e));
		});
	}

	if (onSlide) {
		el.noUiSlider.on('slide', function (e) {
			return onSlide(parse(e));
		});
	}

	if (onStart) {
		el.noUiSlider.on('start', function (e) {
			return onStart(parse(e));
		});
	}

	if (onUpdate) {
		el.noUiSlider.on('update', function (e) {
			return onUpdate(parse(e));
		});
	}
};

var render = function render(_ref2) {
	var props = _ref2.props;
	return (0, _magicVirtualElement2.default)('div', { 'class': ['Range', props.class, props.styleClasses && props.styleClasses.Range_Slider], 'data-style-attr': 'Range_Slider' });
};

exports.default = { afterMount: afterMount, defaultProps: defaultProps, propTypes: propTypes, render: render };
